import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Filtro from "../../../cuentas/components/Filtro";
import FrmCheckout from "../netpay_form/FrmCheckout";
import ServicioContratado from "../../../../Repository/ServicioContratado";
import PropTypes from "prop-types";

const defaultCredenciales = {
    public_key:"",
    secret_key:""
}

const CHECKOUTV2 = ({ cuenta_uuid = '' }) => {
    const  servContratado = new ServicioContratado();
    const [contratados, setContratados] = useState([]);
    const [ credenciales, setCredenciales ] = useState(defaultCredenciales);
    const [ device, setDevice ] = useState({});

    const loadComponent = async() =>{
        const result = await servContratado.listar(cuenta_uuid);
        if(result.status === "ok")
            setContratados( result.response.contratados );
    }

    useEffect(()=>{
        loadComponent();
    },[])

    useEffect(()=>{
        contratados.forEach(element =>{
            if(element.tipoServicio === 'NETPAY_CHECKOUT'){
                setCredenciales( element.credenciales );
                setDevice( element );
            }
        })
    }, [contratados])

    return (
        <Box pt={1} m={1}>
            <Filtro bodyContent={ <FrmCheckout tipoServicioName={ "NETPAY_CHECKOUT" } cuenta_uuid={ cuenta_uuid } credenciales={credenciales} device={device } /> } title={"Llaves"} icon={ "fa-solid fa-key" } open={true} />
        </Box>
    );
}

CHECKOUTV2.propTypes = {
    cuenta_uuid:PropTypes.string.isRequired,
}

export default CHECKOUTV2;